import React, { useState } from "react";
import { LucidePanelRightClose, LucidePanelLeftClose } from "lucide-react";

import Button from "./Button";

const DesignCenter: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"theme" | "component">("theme");
  const [isDesignCenterOpen, setIsDesignCenterOpen] = useState(true);
  return (
    <div
      className={`bg-white border-r border-gray-200 flex flex-col ${
        isDesignCenterOpen ? "w-80" : "w-auto"
      }`}
    >
      <div className="p-4 border-b border-gray-200 flex items-center justify-between">
        {isDesignCenterOpen && (
          <h2 className="text-lg font-semibold">Design Center</h2>
        )}
        <button
          className="p-2 rounded-full hover:bg-gray-100"
          onClick={() => setIsDesignCenterOpen(!isDesignCenterOpen)}
        >
          {isDesignCenterOpen ? (
            <LucidePanelLeftClose className="w-4 h-4" />
          ) : (
            <LucidePanelRightClose className="w-4 h-4" />
          )}
        </button>
      </div>

      {isDesignCenterOpen && (
        <div>
          <div className="p-4">
            <div className="flex items-center border border-gray-200 rounded-md bg-gray-100 p-1">
              <Button
                variant={activeTab === "theme" ? "contained" : "text"}
                size="sm"
                fullWidth
                onClick={() => setActiveTab("theme")}
                color="white"
              >
                Themes
              </Button>
              <Button
                variant={activeTab === "component" ? "contained" : "text"}
                size="sm"
                fullWidth
                onClick={() => setActiveTab("component")}
                color="white"
              >
                Components
              </Button>
            </div>
          </div>

          <div className="p-4"></div>
        </div>
      )}
    </div>
  );
};

export default DesignCenter;
